<template>
  <div class="isolation-remaining-useful-life">
    <label class="isolation-remaining-useful-life__title">
      {{ $t('engineering.isolation-aging.isolation-remaining-useful-life') }}
    </label>
    <b-row class="isolation-remaining-useful-life__boxes-row">
      <b-col class="text-center">
        <label class="isolation-remaining-useful-life__number-box-label">
          {{ $t('fields.engineering.isolation-aging.in-years') }}
        </label>
        <div class="isolation-remaining-useful-life__number-box">
          <s-number
            :fallback-value="numberFallback"
            :value="data.inYears"
            :number-format-options="getFormatOptions(data.decimalNumbersInYears)"
          />
        </div>
      </b-col>
      <b-col class="text-center">
        <label class="isolation-remaining-useful-life__number-box-label">
          {{ $t('fields.engineering.isolation-aging.in-percentage-symbol') }}
        </label>
        <div class="isolation-remaining-useful-life__number-box w-100">
          <s-number
            :fallback-value="numberFallback"
            :value="data.inPercentage"
            :number-format-options="getFormatOptions(data.decimalNumbersInPercentage)"
            :tooltip-format-options="getFormatOptions(percentageTooltipPrecision)"
          />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
const PERCENTAGE_TOOLTIP_PRECISION = 10;

export default {
  name: 'IsolationRemainingUsefulLife',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    numberFallback: '-',
    percentageTooltipPrecision: PERCENTAGE_TOOLTIP_PRECISION,
  }),
  methods: {
    getFormatOptions(precision) {
      if (typeof precision !== 'number') {
        return null;
      }
      return {
        minimumFractionDigits: precision,
        maximumFractionDigits: precision,
      };
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "src/styles/defaults/variables"

  .isolation-remaining-useful-life
    width: 100%
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
    border: 1px solid $color-border-gray
    border-radius: 3px
    padding: 8px
    position: relative
    &__title
      text-align: center
      position: absolute
      width: 100%
      top: 8px
    &__boxes-row
      width: 100%
    &__number-box
      min-width: 100px
      min-height: 50px
      display: flex
      justify-content: center
      align-items: center
      background-color: var(--color-background-dark)
      border: 1px solid $color-background-gray
      border-radius: 3px
      font-weight: bold
      font-size: 1.1em
    &__number-box-label
      margin-bottom: 0
      font-size: .9em

  .manage-fonts_18px
    .isolation-remaining-useful-life
      &__title
        margin-bottom: 10px
</style>
